import { render, staticRenderFns } from "./date-verified.vue?vue&type=template&id=12a6375c&"
import script from "./date-verified.vue?vue&type=script&lang=js&"
export * from "./date-verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a6375c')) {
      api.createRecord('12a6375c', component.options)
    } else {
      api.reload('12a6375c', component.options)
    }
    module.hot.accept("./date-verified.vue?vue&type=template&id=12a6375c&", function () {
      api.rerender('12a6375c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/peopleVerify/components/date-verified.vue"
export default component.exports